<build-section
  [active]="active"
  [title]="details?.sizeSectionTitle">
  <div class="row">
    @for (size of sizes; track size.details.id) {
      <div class="col-md-6">
        <div class="size clearfix mb-4 pointer d-flex align-items-center"
             (click)="activeSize = size; onSelect.emit(size)"
             [class.active]="isActiveSize(size)">
          @if (size.details.shape !== 'TWO-LEVEL-ROUND' && size.details.shape !== 'THR-LEVEL-ROUND' && size.details.shape !== 'FOR-LEVEL-ROUND') {
            <span class="size-shape {{size.details.shape}}"></span>
          }
          @if (size.details.shape == 'TWO-LEVEL-ROUND' || size.details.shape == 'THR-LEVEL-ROUND' || size.details.shape == 'FOR-LEVEL-ROUND') {
            <span class="shape-container">
              <span class="size-shape size-shape-level "></span>
              <span class="size-shape size-shape-level  TWO-LEVEL-ROUND"></span>
              @if (size.details.shape === 'THR-LEVEL-ROUND' || size.details.shape === 'FOR-LEVEL-ROUND') {
                <span class="size-shape size-shape-level  THR-LEVEL-ROUND"></span>
              }
              @if (size.details.shape === 'FOR-LEVEL-ROUND') {
                <span class="size-shape size-shape-level FOR-LEVEL-ROUND"></span>
              }
            </span>
          }
          <div class="size-info">
            <div class="fw-bold">
              {{size.details.value}}
              <span class="measurement">{{size.details.measurement}} - </span>
              <span class="price">
                {{size.minPrice | tryToDiscountPrice: discount: currency}}
              </span>
            </div>
            <div class="size-definition font-sm">
              {{size.details.definition}}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (details?.sizeSectionHelpText) {
    <div class="help-text">
      {{details.sizeSectionHelpText}}
    </div>
  }
</build-section>
